export default "__VITE_ASSET__DBgeWyN0__"